import React from 'react';
import { Select, MenuItem, Typography, SelectChangeEvent } from '@mui/material';
import { OpcionPrecio } from '../types';
import { etiquetaOpcion } from '../domain/pricing';

interface OpcionPrecioDropdownProps {
  opciones: OpcionPrecio[] | null | undefined;
  value: number | null | undefined;
  onChange: (indice: number) => void;
  disabled?: boolean;
}

// SPEC-208 (RN-010) — "etiqueta — $valor" de cada opción, tal como la manda el proveedor.
function textoOpcion(opcion: OpcionPrecio, indice: number): string {
  return `${etiquetaOpcion(opcion, indice)} — $${opcion.valor.toLocaleString('es-CO')}`;
}

// SPEC-208 (RN-007, RN-010) — selector de la opción de precio de la línea, hermano de ColorDropdown
// (mismo estilo). Solo aparece cuando la línea tiene más de una opción; el valor es el índice dentro
// de la copia de la línea.
export function OpcionPrecioDropdown({ opciones, value, onChange, disabled = false }: OpcionPrecioDropdownProps) {
  if (!opciones || opciones.length <= 1) return null;

  const handleChange = (e: SelectChangeEvent<string>) => {
    onChange(Number(e.target.value));
  };

  return (
    <Select
      data-testid="select-opcion-precio"
      // Con copia siempre hay índice (CHECK de la 063); sin él, la línea está en el primer precio (S-5).
      value={String(value ?? 0)}
      onChange={handleChange}
      disabled={disabled}
      renderValue={(selected) => {
        const indice = Number(selected);
        return <Typography sx={{ fontSize: '16px', lineHeight: 1.2, whiteSpace: 'normal' }}>{textoOpcion(opciones[indice], indice)}</Typography>;
      }}
      sx={{
        height: '56px',
        fontSize: '16px',
        borderRadius: '6px',
        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#DFDCE2' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#9B2B9D' },
        '& .MuiSelect-select': { py: 0, px: '14px', display: 'flex', alignItems: 'center' },
        width: '100%',
      }}
    >
      {opciones.map((opcion, indice) => (
        <MenuItem key={indice} value={String(indice)}>
          <Typography sx={{ fontSize: '16px' }}>{textoOpcion(opcion, indice)}</Typography>
        </MenuItem>
      ))}
    </Select>
  );
}
